/**
 * Application Constants
 * These are replaced at BUILD time by Webpack
 */

// Media CDN base URL (Cloudflare R2)
// Both development and production use R2 CDN
// Fallback to /assets only if env var is not set
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'https://media.suncatchers.pt';

// API Configuration
export const API_URL = process.env.REACT_APP_API_URL;
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const ENABLE_DEBUG = process.env.REACT_APP_ENABLE_DEBUG === 'true';
